import { invokeEdgeFunction } from './invokeEdgeFunction';

export type ScheduledEmailPreviewKind = 'raw' | 'template';

export interface ScheduledEmailPreviewResult {
  html: string;
  subject: string;
  previewKind: ScheduledEmailPreviewKind;
  postmarkTemplateAlias?: string | null;
  warning?: string;
  error?: string;
}

export interface PreviewScheduledEmailInput {
  subject?: string | null;
  bodyHtml?: string | null;
  postmarkTemplateAlias?: string | null;
  contentMode?: 'manual' | 'template_wrap' | 'template_only' | null;
  subtitle?: string | null;
}

export async function fetchScheduledEmailPreview(
  input: PreviewScheduledEmailInput,
): Promise<ScheduledEmailPreviewResult> {
  const body: Record<string, unknown> = {};
  if (input.subject !== undefined) body.subject = input.subject;
  if (input.bodyHtml !== undefined) body.body_html = input.bodyHtml;
  if (input.postmarkTemplateAlias !== undefined) {
    body.postmark_template_alias = input.postmarkTemplateAlias;
  }
  if (input.contentMode !== undefined) body.content_mode = input.contentMode;
  if (input.subtitle !== undefined) body.subtitle = input.subtitle;

  const result = await invokeEdgeFunction<ScheduledEmailPreviewResult>(
    'preview-scheduled-email',
    body,
  );
  if (result.error) {
    throw new Error(result.error);
  }
  if (!result.html) {
    throw new Error('Preview returned no HTML');
  }
  return result;
}
